import React from 'react';


export enum ImageSize {
  XS = '50',
  S = '100',
  M = '300',
  L = '500',
  XL = '1000',
  XXL = '2880',
  original = 'original',
}

export enum ImageHeight {
  S = '600',
}

export const imageHooks = {
  useSize(size: ImageSize, image: string): string {
    return React.useMemo(() => {
      return image === '' ? '' : size === ImageSize.original ? image : `${image}?v=w${size}`;
    }, [image, size]);
  },
  useHeight(height: ImageHeight, image: string): string {
    return React.useMemo(() => {
      return image === '' ? '' : `${image}?v=h${height}`;
    }, [image, height]);
  },
};
